import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop est un composant qui ramène automatiquement la page en haut
 * lors d'un changement de route dans l'application.
 * Il résout le problème de redirection vers le bas de la page lors de la navigation.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Lorsque le chemin change, faire défiler la page vers le haut
    window.scrollTo(0, 0);
  }, [pathname]);

  return null; // Ce composant ne rend rien
};

export default ScrollToTop;
